import { cn } from "@/lib/utils";
import { useMatches } from "@tanstack/react-router";
import { Fragment, useEffect, useRef } from "react";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage
} from "@/components/ui/breadcrumb";
import { useIsMobile } from "@/hooks/use-mobile";
import { FeedbackButton } from "@/feedback/FeedbackButton";

export function MainNav({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  const matches = useMatches();
  const isMobile = useIsMobile();

  const matchesWithBreadcrumbs = matches
    .filter(match => match.staticData.breadcrumb !== undefined);

  const ref = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (isMobile) {
      ref.current?.scrollIntoView({ behavior: "smooth", inline: "end"})
    }
  }, [matches]);

  return (
    <nav
      className={cn(
        "flex items-center justify-between space-x-4 lg:space-x-6 flex-1 flex-nowrap",
        className
      )}
      {...props}
    >
      <Breadcrumb>
        <BreadcrumbList className="flex-nowrap whitespace-nowrap">
          {
            matchesWithBreadcrumbs.map((match, index) => (
              <Fragment key={index}>
                {
                  index !== matchesWithBreadcrumbs.length - 1 ? (
                    <>
                      <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                          {match.staticData.breadcrumb && <match.staticData.breadcrumb/>}
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator/>
                    </>
                  ) : (
                    <BreadcrumbItem>
                      <BreadcrumbPage ref={ref} className="pr-4">
                        {match.staticData.breadcrumb && <match.staticData.breadcrumb/>}
                      </BreadcrumbPage>
                    </BreadcrumbItem>
                  )
                }
              </Fragment>
            ))
          }
        </BreadcrumbList>
      </Breadcrumb>
      <div className="hidden lg:block">
        <FeedbackButton feature="Top navbar"/>
      </div>
    </nav>
  );
}
